var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoApplicationsYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 127,
    viewBox: "0 0 101 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1011 61.4191L57.9709 54.3191L22.2109 33.6691L5.69092 24.1292L2.21094 42.1191V50.1192L5.69092 52.1291V76.1291L37.061 94.2392V70.2391L51.001 78.2892V90.2892L54.7109 92.4292L57.9709 94.3091V82.3091L61.4609 84.3191V76.3292L59.1011 61.4191ZM30.0911 82.2091L12.661 72.1492V56.1492L25.6909 63.6691L27.511 64.7192L30.0911 66.2091V82.2091Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4316 113.609V114.339L68.4316 124.339V112.349L78.8816 118.379L87.7517 113.949L88.4316 113.609Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8809 100.379V108.379L88.4309 113.609L87.751 113.949L78.8809 118.379V110.379L81.4609 109.089L88.4309 105.609L91.4509 104.089L98.8809 100.379Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8816 100.379L91.4517 104.089L88.4316 105.609L81.4617 109.089L78.8816 110.379L68.4316 104.349L81.0117 98.0591L88.4316 94.3491L98.8816 100.379Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4316 82.3491V94.3491L81.0117 98.0591L68.4316 104.349V92.3491L71.0017 91.0691L77.2917 87.9191L81.4617 85.8391L88.4316 82.3491Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4309 82.3492L81.4609 85.8392L77.291 87.9192L71.001 91.0692L68.4309 92.3492L65.4009 90.5992L62.1509 88.7192L61.4609 88.3192L74.031 82.0392L77.9709 80.0692L81.4609 78.3192L88.4309 82.3492Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9717 76.0692V80.0692L74.0317 82.0392L61.4617 88.3192V92.5692L57.9717 94.3092V82.3092L61.4617 84.3192L71.0017 79.5492L77.9717 76.0692Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0015 78.2891V87.2691L37.0615 94.2391V70.2391L51.0015 78.2891Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5111 64.7192L25.691 65.6392L12.6611 72.1492V56.1492L25.691 63.6692L27.5111 64.7192Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0912 66.2091V82.2091L12.6611 72.1491L25.691 65.6391L27.5111 64.7191L30.0912 66.2091Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9714 44.3192L57.9714 54.3192L22.2114 33.6692L5.69141 24.1292L9.40149 22.2692L22.6414 29.9192L57.9714 50.3192L74.2615 42.1792L77.9714 44.3192Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9714 32.3192L57.9714 42.3192L24.0315 22.7192L16.8314 18.5592L5.69141 12.1292L25.6914 2.12915L77.9714 32.3192Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9707 32.3191V40.3191L74.2607 42.1791L57.9707 50.3191V42.3191L77.9707 32.3191Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9714 42.3192V50.3192L22.6414 29.9191L9.40149 22.2692L5.69141 20.1292V12.1292L16.8314 18.5592L24.0315 22.7192L57.9714 42.3192Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4607 66.3291L61.4607 76.3291L59.1008 61.4191L57.9707 54.3191L77.9707 44.3191L81.4607 66.3291Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4609 66.3291V74.3191L77.9709 76.0691L71.001 79.5491L61.4609 84.3191V76.3291L81.4609 66.3291Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8809 110.379V118.379L68.4309 112.349V124.339L61.4609 120.319V108.319L51.001 102.279V94.2891L61.4609 100.319V88.3191L62.1509 88.7191L65.4009 90.5991L68.4309 92.3491V104.349L78.8809 110.379Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4609 92.5692V100.319L51.001 94.2892L54.7109 92.4292L57.9709 94.3092L61.4609 92.5692Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApplicationsYet);
export default __webpack_public_path__ + "static/media/no-applications-yet.914bec619405e0407e0140c3d1879f73.svg";
export { ForwardRef as ReactComponent };